import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Payroll extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Payroll</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Unsatisfied and
                                5-Very Satisfied...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formTimeTracking"
                                controlId="formTimeTracking"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    32. How satisfied are you with the time tracking system?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formTimeTracking"
                                    id="formTimeTracking-1"
                                    defaultChecked={this.props.formTimeTracking === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formTimeTracking"
                                    id="formTimeTracking-2"
                                    defaultChecked={this.props.formTimeTracking === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formTimeTracking"
                                    id="formTimeTracking-3"
                                    defaultChecked={this.props.formTimeTracking === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formTimeTracking"
                                    id="formTimeTracking-4"
                                    defaultChecked={this.props.formTimeTracking === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formTimeTracking"
                                    id="formTimeTracking-5"
                                    defaultChecked={this.props.formTimeTracking === 5}
                                />
                                </Form.Group>

                                <Form.Group
                                as={Row}
                                name="formPayrollSystem"
                                controlId="formPayrollSystem"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    33. How satisfied are you with the payroll system?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formPayrollSystem"
                                    id="formPayrollSystem-1"
                                    defaultChecked={this.props.formPayrollSystem === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formPayrollSystem"
                                    id="formPayrollSystem-2"
                                    defaultChecked={this.props.formPayrollSystem === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formPayrollSystem"
                                    id="formPayrollSystem-3"
                                    defaultChecked={this.props.formPayrollSystem === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formPayrollSystem"
                                    id="formPayrollSystem-4"
                                    defaultChecked={this.props.formPayrollSystem === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formPayrollSystem"
                                    id="formPayrollSystem-5"
                                    defaultChecked={this.props.formPayrollSystem === 5}
                                />
                                </Form.Group>

                                
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Payroll;